import { render, staticRenderFns } from "./teacherIdentitySelect.vue?vue&type=template&id=2ae247e2&scoped=true&"
import script from "./teacherIdentitySelect.vue?vue&type=script&lang=js&"
export * from "./teacherIdentitySelect.vue?vue&type=script&lang=js&"
import style0 from "./teacherIdentitySelect.vue?vue&type=style&index=0&id=2ae247e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae247e2",
  null
  
)

export default component.exports